module.exports = __webpack_public_path__ + "static/media/arrowright.8d0b1166.svg";